export default __webpack_public_path__ + "static/lupa-adc3c2d14971e24dcf7bb762d4cdb66c.png";